import React from "react";
import { Redirect, useParams } from "react-router-dom";
import Cookies from "universal-cookie";

import config from "config";

const cookies = new Cookies();

const SingleSignOn = () => {
  const params = useParams<{ connection?: string }>();

  /**
   * Sets the connection that the user should log in to, parsed from path
   */
  if (params.connection) {
    localStorage.setItem(
      `codat-auth0-connection-${config.ENVIRONMENT.toLowerCase()}`,
      params.connection
    );
  }

  /**
   * Sets a cookie that tells us that the user is using Auth0 before redirecting
   * to the homepage, which then sends them to the Auth0 universal login page
   */
  cookies.set(`isAuth0User-${config.ENVIRONMENT}`, true, {
    domain: ".codat.io",
    path: "/",
  });

  return <Redirect to="/" />;
};

export default SingleSignOn;
